import { Outlet } from "react-router-dom";
import Header from "../Components/Header";
import BottomNavigation from "../Components/BottomNavigation";

const MainLayout = () => {
  return (
    <>
      <Header />

      <div style={{ paddingTop: "100px", paddingBottom: "80px" }}>
        <Outlet />
      </div>

      <BottomNavigation />
    </>
  );
};

export default MainLayout;